import React, { useState, useRef, useEffect } from "react";
import EnvSelector from "../onBoarding/components/env-selector";
import { translate } from "../../vendors/react-translate/ReactTranslate";
import {
  LOCAL_STORAGE_KEYS,
  SAML_PROVIDER_CLALIT,
  SAML_PROVIDER_LEUMIT,
} from "../../assets/appConstants";
import { getMicrosoftLogoutUrl } from "../../services/firebase";
import SsoSwitchUserModal from "./SsoSwitchUserModal";
import ClinicianWebLoginSelector from "./ClinicianWebLoginSelector";

const SAML_SAVED_PROVIDERS = [SAML_PROVIDER_CLALIT, SAML_PROVIDER_LEUMIT];

const SettingsButton = ({
  t,
  language,
  onClearSamlProvider,
  showClinicianWebLoginSelector,
}) => {
  const [showMenu, setShowMenu] = useState(false);
  const [hasSamlProvider, setHasSamlProvider] = useState(false);
  const [microsoftLogoutUrl, setMicrosoftLogoutUrl] = useState(null);
  const [shouldRestoreMenu, setShouldRestoreMenu] = useState(false);
  const menuRef = useRef(null);

  const refreshSamlProviderState = () => {
    const lastSamlProvider = localStorage.getItem(LOCAL_STORAGE_KEYS.LAST_SAML_PROVIDER);
    setHasSamlProvider(SAML_SAVED_PROVIDERS.includes(lastSamlProvider));
  };

  useEffect(() => {
    refreshSamlProviderState();

    function handleClickOutside(event) {
      if (menuRef.current && !menuRef.current.contains(event.target)) {
        setShowMenu(false);
      }
    }

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const toggleMenu = () => {
    if (!showMenu) {
      refreshSamlProviderState();
    }
    setShowMenu(!showMenu);
  };

  const closeMicrosoftLogoutPanel = () => {
    setMicrosoftLogoutUrl(null);
    if (shouldRestoreMenu) {
      setShowMenu(true);
    }
    setShouldRestoreMenu(false);
  };

  const handleSwitchAccount = () => {
    setShouldRestoreMenu(showMenu);
    setShowMenu(false);
    setMicrosoftLogoutUrl(getMicrosoftLogoutUrl());
  };

  const handleAfterSsoCleared = () => {
    setHasSamlProvider(false);
    setShowMenu(false);
    setMicrosoftLogoutUrl(null);
    setShouldRestoreMenu(false);
    if (onClearSamlProvider && typeof onClearSamlProvider === "function") {
      onClearSamlProvider();
    }
  };

  return (
    <div ref={menuRef} style={{ position: "relative", zIndex: 13000 }}>
      <div
        onClick={toggleMenu}
        style={{
          position: "absolute",
          right: "1px",
          top: "15px",
          width: "40px",
          height: "40px",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          cursor: "pointer",
          zIndex: 10
        }}
      >
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <circle cx="12" cy="6" r="2" fill="#888888" />
          <circle cx="12" cy="12" r="2" fill="#888888" />
          <circle cx="12" cy="18" r="2" fill="#888888" />
        </svg>
      </div>

      {showMenu && (
        <div
          style={{
            position: "absolute",
            right: "0",
            top: "50px",
            backgroundColor: "white",
            boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.1)",
            borderRadius: "8px",
            padding: "10px",
            zIndex: 13001,
            minWidth: "180px"
          }}
        >
          <div style={{ marginBottom: "10px" }}>
            <EnvSelector />
          </div>

          {showClinicianWebLoginSelector && (
            <div style={{ marginBottom: "10px" }}>
              <ClinicianWebLoginSelector t={t} />
            </div>
          )}

          {hasSamlProvider && (
            <div
              onClick={handleSwitchAccount}
              style={{
                padding: "8px 10px",
                cursor: "pointer",
                borderRadius: "4px",
                transition: "background-color 0.2s",
                fontSize: "14px",
                display: "flex",
                color: "black",
                alignItems: "center",
                justifyContent: "center",
                fontWeight: "500",
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.backgroundColor = "#f5f5f5";
                e.currentTarget.style.color = "#2B6CB0";
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.backgroundColor = "transparent";
                e.currentTarget.style.color = "black";
              }}
            >
              {t("login.settings.switchAccount")}
            </div>
          )}
        </div>
      )}

      <SsoSwitchUserModal
        logoutUrl={microsoftLogoutUrl}
        onClose={closeMicrosoftLogoutPanel}
        onAfterSsoCleared={handleAfterSsoCleared}
        t={t}
        language={language}
      />
    </div>
  );
};

export default translate("login")(SettingsButton);
